import React from 'react';
import ResetPassword from './ResetPassword';
import ThemeErrorBoundary from '../../theme/ThemeErrorBoundary';
import { StyledComponentsIntegration } from '../../theme/StyledComponentsIntegration';

/**
 * ResetPasswordWrapper
 * 
 * This component wraps the ResetPassword component with the StyledComponentsIntegration
 * to ensure that styled-components has access to the theme.
 */
const ResetPasswordWrapper: React.FC = () => {
  return (
    <ThemeErrorBoundary>
      <StyledComponentsIntegration>
        <ResetPassword />
      </StyledComponentsIntegration>
    </ThemeErrorBoundary>
  );
};

export default ResetPasswordWrapper;